import React, { useEffect, useState } from 'react';
import './mobile_menu.css';
import { useDispatch, useSelector } from "react-redux";
import {
    filtersAction,
    setChoiceAddressFormAction,
    setMobileMenuAction,
    setScheduleAction,
    setUserBarAction
} from "../../redux/actions";
import { getFiltersSagaAction, getMyReservesSagaAction } from "../../redux/sagaActions";
import { getSubscriptionsSagaAction } from "../../redux/sagaActions";
import { SCHEDULE_INITIAL } from "../../redux/initialStateConstants";

const MobileMenu = () => {
    const dispatch = useDispatch();
    const mobile_menu = useSelector(state => state.mobile_menu);
    const filters = useSelector(state => state.filters);
    const user = useSelector(state => state.user);
    const choice_address_form = useSelector(state => state.choice_address_form);
    const schedule_active = useSelector(state => state.schedule_active);

    const [filtersActive, setFiltersActive] = useState(false);

    useEffect(() => {
        // Активное состояние фильтров
        if (
            filters.coaches.filter(el => el.active).length
            || filters.types.filter(el => el.active).length
        ) {
            setFiltersActive(true);
        }
        else {
            setFiltersActive(false);
        }
    }, [filters]);

    return (
        <div className={ `m_menu ${ mobile_menu ? 'm_menu--open' : '' }` }>
            <div className="m_menu__header">
                <div className="m_menu__close"
                    onClick={ () => {
                        dispatch(setMobileMenuAction(false));
                    } }
                />
            </div>
            <div className="m_menu__items">
                {
                    user.id &&
                    <div className="m_menu__item m_menu__item--my-services"
                         onClick={ () => {
                             // Закрываем мобильное меню
                             dispatch(setMobileMenuAction(false));
                             // Запрашиваем список записей
                             dispatch(getMyReservesSagaAction());
                         } }
                    >Мои записи</div>
                }
                {
                    user.id && schedule_active === 1 &&
                    <div className="m_menu__item m_menu__item--services"
                         onClick={ () => {
                             // Закрываем мобильное меню
                             dispatch(setMobileMenuAction(false));
                             // Открываем компонент с расписанием
                             dispatch(setScheduleAction({
                                 ...SCHEDULE_INITIAL,
                                 open: true
                             }));
                         } }
                    >Запись на услуги</div>
                }

                <div className="m_menu__item m_menu__item--filter"
                    onClick={ () => {
                        // Закрываем мобильное меню
                        dispatch(setMobileMenuAction(false));
                        // Открываем фильтры
                        dispatch(filtersAction({ ...filters, open: true }));
                        // Запрашиваем фильтры
                        dispatch(getFiltersSagaAction());
                    } }
                >Фильтры</div>
                <div className="m_menu__item m_menu__item--user"
                    onClick={ () => {
                        // Закрываем мобильное меню
                        dispatch(setMobileMenuAction(false));

                        // Запрашиваем список абонементов, если пользователь залогинен
                        if (user.id) {
                            dispatch(getSubscriptionsSagaAction());
                        }

                        dispatch(setUserBarAction(true));
                    } }
                >Профиль</div>
                {
                    choice_address_form.addresses.length > 1 &&
                    <div className="m_menu__item m_menu__item--address"
                         onClick={ () => {
                             // Закрываем мобильное меню
                             dispatch(setMobileMenuAction(false));

                             dispatch(setChoiceAddressFormAction({
                                 ...choice_address_form,
                                 open: true
                             }));
                         } }
                    >
                        Выбрать адрес
                    </div>
                }
            </div>
        </div>
    );
};

export default MobileMenu;